import { ControlsToggleExtraContent } from "@jelly/lesson";
import config from "appConfig";

export const absorption0: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/front-0.wav`,
      text: "Sample A",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/back-0.wav`,
      text: "Sample B",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
];

export const absorption50a: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/front-a-50.wav`,
      text: "Sample A",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/back-a-50.wav`,
      text: "Sample B",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
];

export const absorption100a: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/front-a-100.wav`,
      text: "Sample A",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/back-a-100.wav`,
      text: "Sample B",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
];

export const absorption50b: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/front-b-50.wav`,
      text: "Sample A",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/back-b-50.wav`,
      text: "Sample B",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
];

export const absorption100b: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/front-b-100.wav`,
      text: "Sample A",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/13/principle/back-b-100.wav`,
      text: "Sample B",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
    },
  },
];
